<form [formGroup]="emailForm" class="email-form" data-testid="account-email-form">
    <div>
        <form-label [for]="'email'" [label]="subtitle(1110)"></form-label>
        <form-email-input [emailControl]="emailControl"></form-email-input>
    </div>
    <form-action-buttons>
        <form-button [subtitle]="subtitle(71)"
                     [btnType]="'cancel'"
                     (click)="closeForm()">
        </form-button>
        <form-button [subtitle]="subtitle(1255)"
                     [btnType]="'confirm'"
                     (click)="changeAccountEmail()">
        </form-button>
    </form-action-buttons>
</form>
